<template>
    <DashboardContentLayout class="space-y-8" :heading="$t('views.farmToFarm.heading')">
        <FarmToFarmSteps />
    </DashboardContentLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import FarmToFarmSteps from './FarmToFarmSteps.vue';

/**
 * Farm-to-farm benchmark report, over months, quarters, half-years or full years.
 *
 * Thin by design, per the repository README: layout and composition only.
 */
export default defineComponent({
    components: { DashboardContentLayout, FarmToFarmSteps },
});
</script>
